import React from "react"

import UserGroupMembershipStore from "@components/modals/EditModal/avatar-membership.store"

export const MembershipContext =
  React.createContext<UserGroupMembershipStore | null>(null)

export default MembershipContext
